import { Component, EventEmitter, Output } from '@angular/core';
import { chatBotFadeInAnimationSequence } from '../../../animations/chatAnimations';

@Component({
  selector: 'smart-fix-bedrock-chat-toggle',
  templateUrl: './bedrock-chat-toggle.component.html',
  styleUrls: ['./bedrock-chat-toggle.component.scss'],
  animations: [chatBotFadeInAnimationSequence],
})
export class BedrockChatToggleComponent {
  @Output() modeSelected = new EventEmitter<string>();

  // Only RAG mode is enabled - agent-llm and docs modes are disabled
  modes = ['rag'];
  selectedMode = 'rag'; // Default to RAG mode

  onModeChange(mode: string) {
    this.modeSelected.emit(mode);
  }
}
